export default "__VITE_ASSET__68bc16ab__"